/* ---------------------------------------------------------------------------
   Closer Look - per image framing
   The section crossfades two <img> layers and swaps their src. This watches for
   that swap and applies the fit, focal point and scale saved on whichever block
   the new src belongs to, so each feature can be framed differently.

   Deliberately separate from closer-look.js: it needs no hook inside that file
   and does nothing at all if these settings are left on Inherit.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';

  function fileOf(url) {
    if (!url) return '';
    return String(url).split('?')[0].split('/').pop();
  }

  function readData(root) {
    var node = root.querySelector('[data-hp-cl-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function buildIndex(data) {
    var map = {};
    ['colors', 'features'].forEach(function (key) {
      (data[key] || []).forEach(function (item) {
        [item.image, item.imageMobile].forEach(function (src) {
          var f = fileOf(src);
          if (f) map[f] = item;
        });
      });
    });
    return map;
  }

  function apply(img, item, isMobile) {
    if (!item) return;

    var fit = item.fit && item.fit !== 'inherit' ? item.fit : '';
    var pos = '';
    if (isMobile && item.posMobile && item.posMobile !== 'inherit') pos = item.posMobile;
    else if (item.pos && item.pos !== 'inherit') pos = item.pos;

    var scale = parseFloat(item.scale);
    if (isNaN(scale)) scale = 100;

    img.style.objectFit = fit;
    img.style.objectPosition = pos;
    img.style.transform = scale === 100 ? '' : 'scale(' + (scale / 100) + ')';
  }

  function init(root) {
    if (root.hpClMedia) return;
    var data = readData(root);
    if (!data) return;
    var index = buildIndex(data);
    if (!Object.keys(index).length) return;
    root.hpClMedia = true;

    var mq = window.matchMedia(MOBILE);
    var imgs = [].slice.call(root.querySelectorAll('.hp-cl__img, .hp-cl__viewer-media img'));
    if (!imgs.length) return;

    function refresh() {
      imgs.forEach(function (img) {
        apply(img, index[fileOf(img.getAttribute('src'))], mq.matches);
      });
    }

    var mo = new MutationObserver(refresh);
    imgs.forEach(function (img) {
      mo.observe(img, { attributes: true, attributeFilter: ['src'] });
    });

    if (mq.addEventListener) mq.addEventListener('change', refresh);
    else if (mq.addListener) mq.addListener(refresh);

    refresh();
  }

  function boot(scope) {
    var root = scope || document;
    [].slice.call(root.querySelectorAll('.hp-cl')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
